import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const statusFilter = [
     { text: "Active", value: "active" },
     { text: "Inactive", value: "inactive" },
 ]

const paymentFilter = [
     { text: "Paid", value: "Paid" },
     { text: "Unpaid", value: "Unpaid" },
];

const columns = [
     {
          title: "User",
          dataIndex: "userDetails",
          render: defaultRender,
     },
     {
          title: 'Mobile No',
          dataIndex: 'mobile_no',
          render: defaultRender,
     },
     {
          title: 'Status',
          dataIndex: 'statusTag',
          render: defaultRender,
          filters: statusFilter,
          onFilter: (value, record) => {
               return record?.status === value;
          },
     },
     {
          title: 'File No.',
          dataIndex: 'file_number',
          render: defaultRender,
     },
     {
          title: 'File',
          dataIndex: 'file',
          render: (value) => <StatusBadge status={value} />,
     },
     {
          title: 'Task',
          dataIndex: 'task',
          render: defaultRender,
     },
     {
          title: 'Payment',
          dataIndex: 'paymentText',
          render: defaultRender,
          filters: paymentFilter,
          onFilter: (value, record) => {
              return record?.payment === value;
          },
     },
     {
          title: 'Assigned To',
          dataIndex: 'assign_name',
          render: defaultRender,
     },
     {
          title: 'Created Date',
          dataIndex: 'created_at',
          render: defaultRender,
     },
     {
          title: "Action",
          dataIndex: "action",
          render: defaultRender,
     },
];

export default columns;
